module.exports = __webpack_public_path__ + "static/img/logo.68ee13b8.svg";